'use strict';

/**
 * Layout for matching elements
 *
 * @category   View
 * @module     import
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoLayoutView = require('base/Colido.LayoutView');
var MatchListView = require('../partials/match-list');

var template = require('../../templates/components/match.hbs');

var MatchComponent = ColidoLayoutView.extend({
    template: template,

    ui: {
        container: '.import-component',
        defaultsSizeSelect: 'select[name="size"]',
        defaultsWeightSelect: 'select[name="weight"]',
        defaultsCurrencySelect: 'select[name="currency"]',
        buttonStartImport: '[data-action="start-import"]',
        countMatchedColumns: '#matched-columns',
        countDismissedColumns: '#dismissed-columns',
        buttonReMatch: '[data-action="re-match"]',
        errorMessage: '.error-message',
    },

    events: {
        'click @ui.buttonStartImport': 'onActionStartImport',
        'click @ui.buttonReMatch': 'onActionReMatch',
        'change @ui.defaultsSizeSelect': 'onDefaultUnitChanged',
        'change @ui.defaultsWeightSelect': 'onDefaultUnitChanged',
        'change @ui.defaultsCurrencySelect': 'onDefaultUnitChanged',
    },

    collectionEvents: {
        'change:fieldname': 'modelChanged',
        'change:dismissed': 'modelChanged',
        'invalid': 'modelInvalid',
    },

    modelEvents: {
        'change:state': 'stateChanged',
    },

    childEvents: {
        'component:match:field:changed': 'onFieldChanged',
    },

    regions: {
        matchColumnsRegion: '#subregion-match-columns',
    },

    viewData: {
        step: function() {
            return this.getOption('step') || 2;
        },
    },

    matchingListView: null,

    invalidationShown: false,

    onRender: function() {
        this.matchingListView = new MatchListView({
            collection: this.collection,
            fieldsCollection: this.getOption('fieldsCollection'),
            importModel: this.model,
        });

        this.matchColumnsRegion.show(this.matchingListView);
    },

    /**
     * Is triggered, when the import should be started
     */
    onActionStartImport: function() {
        this.triggerMethod('component:match:import:start');
        this.ui.buttonStartImport.prop('disabled', true).addClass('is-loading');
        if (this.invalidationShown) {
            $('.scroll-container').stop().animate(
                {scrollTop: $('.scroll-container')[0].scrollTop + $('#subregion-match-columns').offset().top},
                400
            );
        }
    },

    /**
     * Is triggered, when import is finished
     */
    stateChanged: function(model, state) {
        if (state === 'mapping' || state === 'remap') {
            this.enableButtonStartImport();
        } else if (state === 'upload') {
            this.ui.errorMessage.html('');
        }
    },

    enableButtonStartImport: function () {
        this.ui.buttonStartImport.prop('disabled', false).removeClass('is-loading');
    },

    /**
     * Is triggered from layout view, on proceed/next click
     */
    onParentProceed: function() {
        this.onActionStartImport();
    },

    /**
     * Render select fields on show
     */
    onShow: function() {
        this.renderSelectFields();
    },

    /**
     * Is triggered, when rematch is clicked
     * @param {object} event The klick event
     */
    onActionReMatch: function(event) {
        this.model.set('state', 'mapping');
    },

    onFieldChanged: function(childView, field) {
        this.triggerMethod('component:match:field:changed', field);
    },

    /**
     * Updates the ui counts for selected/dismissed, removes error message
     * and re-enables 'start import' button
     * @param {ImportModule.MatchesCollection} collection The collection with the matches
     */
    modelChanged: function() {
        this.ui.countMatchedColumns.html(this.collection.selectedColumns());
        this.ui.countDismissedColumns.html(this.collection.dismissedColumns());
        this.ui.container.attr('data-state', this.collection.selectedColumns() > 0 ? 'selected' : 'pending');
        this.ui.container.removeClass('has-error');
        this.enableButtonStartImport();
        this.invalidationShown = false;
    },

    /**
     * Shows error message and re-enables 'start import' button
     * @param {ImportModule.ImportModel} model The import model
     * @param {String} error The error message
     */
    modelInvalid: function (model, error) {
        if (this.model.isValidationEnabled()) {
            this.ui.container.addClass('has-error');
            this.enableButtonStartImport();

            if (!this.invalidationShown) {
                var childView = this.matchingListView.children.findByModel(model);
                if (childView) {
                    var currScrollLeft = $('.import-match-list-wrapper')[0].scrollLeft;
                    var offset = childView.$el.offset();
                    var newPos = currScrollLeft + offset.left - this.getPxSize(3);
                    this.$('.import-match-list-wrapper').animate({
                        scrollLeft: newPos,
                    }, 400);

                    this.invalidationShown = true;
                }
            }
        }
    },

    /**
     * Is triggered, when a default unit has changed
     * @param {object} event The change event
     */
    onDefaultUnitChanged: function(event) {
        var $curTarget = $(event.currentTarget);
        var apiColumn = $curTarget.data('apicolumn');

        this.model.set(apiColumn, $curTarget.val());
        this.model.set('state', 'remap');
        this.model.disableValidation();
        this.model.save();
    },

    /**
     * Renders the select field for currency selection
     * @private
     */
    renderSelectFields: function() {
        this.renderSelectOptions(
            this.ui.defaultsCurrencySelect,
            App.radio().request('currencies:collection'),
            'key',
            'name',
            function(item) {
                return item.value == App.user.getCurrency();
            }
        );

        this.renderSelectOptions(
            this.ui.defaultsSizeSelect,
            App.BaseModule.sizeUnitsCollection,
            'key',
            'name',
            function(item) {
                return item.value == App.user.get('defaultSizeUnit');
            }
        );

        this.renderSelectOptions(
            this.ui.defaultsWeightSelect,
            App.BaseModule.weightUnitsCollection,
            'key',
            'name',
            function(item) {
                return item.value == App.user.get('defaultWeightUnit');
            }
        );
    },
});

module.exports = MatchComponent;